import { render } from "./AccordionTab.vue?vue&type=template&id=192bce24"
import script from "./AccordionTab.vue?vue&type=script&lang=js"
export * from "./AccordionTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__